if (!customElements.get('count-down-timer')) {
  customElements.define('count-down-timer', class CountdownTimer extends HTMLElement {
    constructor() {
      super();

      if (this.dataset.timezone) {
        fetch(`https://worldtimeapi.org/api/timezone/${this.dataset.timezone}`)
          .then(resp => resp.json())
          .then(data => {
            const datetime = data.datetime
            this.countDownStartTime = new Date(datetime.split('.')[0].replace('T', ' ')).getTime()
            this.initCountdown()
          })
          .catch(err => {
            this.initFail()
          })
      } else {
        this.initFail()
      }
    }

    initCountdown() {
      const pattern1 = /^\d{4}-\d{2}-\d{2}$/;
      const pattern2 = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/;
      if(pattern1.test(this.dataset.endtime) || pattern2.test(this.dataset.endtime)) {
        var finalDate = this.dataset.endtime;
        if(pattern1.test(this.dataset.endtime)) {
          finalDate += ' 00:00:00';
        } else if(pattern2.test(this.dataset.endtime)) {
          finalDate += ':00';
        }
        this.countDownEndTime = new Date(finalDate).getTime();
        this.initElements();
        this.interval = setInterval(this.run.bind(this), 1000);
      } else {
        this.initFail();
      }
    }

    initElements() {
      this.daysElement = this.querySelector('.countdown__days__value');
      this.hoursElement = this.querySelector('.countdown__hours__value');
      this.minutesElement = this.querySelector('.countdown__minutes__value');
      this.secondsElement = this.querySelector('.countdown__seconds__value');
    }

    initFail() {
      this.remove();
    }

    run() {
      this.countDownStartTime += 1000
      const now = this.countDownStartTime

      // Find the distance between now and the count down date
      const distance = this.countDownEndTime - now;

      // Time calculations for days, hours, minutes and seconds
      const daysNumber = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hoursNumber = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutesNumber = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const secondsNumber = Math.floor((distance % (1000 * 60)) / 1000);
      if(!daysNumber) {
        this.daysElement.parentElement.classList.add('hidden');
      } else {
        this.daysElement.textContent = daysNumber;
      }

      if(!hoursNumber) {
        this.hoursElement.parentElement.classList.add('hidden');
      } else {
        this.hoursElement.textContent = hoursNumber;
      }

      this.minutesElement.textContent = minutesNumber;
      this.secondsElement.textContent = secondsNumber;

      // If the count down is finished, write some text
      if (distance < 0) {
        clearInterval(this.interval);
        this.showMessage();
        this.classList.add('expired');
      }
    }

    showMessage() {
      const msg = this.dataset.msg
      const timer = this.querySelector('.countdown__timer-simple')
      timer.innerHTML = msg
    }
  })
}
